import { createElement } from 'react';
import { ConfigurationListItem } from '../ConfigurationUnderwriterList';
import advocusNationalIcon from './svg/advocus-national.svg';
import alamoTitleIcon from './svg/alamo-title.svg';
import alliantNationalIcon from './svg/alliant-national.svg';
import americanEagleIcon from './svg/american-eagle.svg';
import americanGuarantyIcon from './svg/american-guaranty.svg';
import americanSecurityIcon from './svg/american-security.svg';
import amTrustIcon from './svg/am-trust.svg';
import arsenalIcon from './svg/arsenal.svg';
import attorneysTitleGuarantyFundIcon from './svg/attorneys-title-guaranty-fund.svg';
import bankersGuaranteeIcon from './svg/bankers-guarantee.svg';
import caticIcon from './svg/catic.svg';
import chicagoTitleIcon from './svg/chicago-title.svg';
import commonwealthLandIcon from './svg/commonwealth-land.svg';
import conestogaTitleIcon from './svg/conestoga-title.svg';
import dakotaHomesteadIcon from './svg/dakota-homestead.svg';
import defaultFAIcon from './svg/default-fa.svg';
import dhiTitleIcon from './svg/dhi-title.svg';
import domaTitleIcon from './svg/doma-title.svg';
import entitleIcon from './svg/entitle.svg';
import essentIcon from './svg/essent.svg';
import fidelityNationalIcon from './svg/fidelity-national.svg';
import firstNationalIcon from './svg/first-national.svg';
import generalTitleIcon from './svg/general-title.svg';
import impactTitleIcon from './svg/impact-title.svg';
import investorsTitleIcon from './svg/investors-title.svg';
import lighthouseTitleIcon from './svg/lighthouse-title.svg';
import nationalTitleNYIcon from './svg/national-title-ny.svg';
import oldRepublicIcon from './svg/old-republic.svg';
import otherIcon from './svg/other.svg';
import premierLandTitleIcon from './svg/premier-land-title.svg';
import radianTitleIcon from './svg/radian-title.svg';
import realAdvantageTitleIcon from './svg/real-advantage-title.svg';
import rocketTitleIcon from './svg/rocket-title.svg';
import securityTitleGuarantyIcon from './svg/security-title-guaranty.svg';
import sierraTitleIcon from './svg/sierra-title.svg';
import southwestLandTitleIcon from './svg/southwest-land-title.svg';
import stewartTitleGuarantyIcon from './svg/stewart-title-guaranty.svg';
import texanTitleIcon from './svg/texan-title.svg';
import titleResourcesGuarantyIcon from './svg/title-resources-guaranty.svg';
import usNationalTitleIcon from './svg/us-national-title.svg';
import westcorLandTitleIcon from './svg/westcor-land-title.svg';
import wfgNationalTitleIcon from './svg/wfg-national-title.svg';
import worthNationalTitleIcon from './svg/worth-national-title.svg';

export type UnderwriterIconSrc = string;

const UNDERWRITER_ICON_MAP: Record<string, UnderwriterIconSrc> = {
  'Advocus National Title Insurance Company': advocusNationalIcon,
  'Alamo Title Insurance Company': alamoTitleIcon,
  'Alliant National Title Insurance Company, Inc.': alliantNationalIcon,
  'American Eagle Title Insurance Company': americanEagleIcon,
  'American Guaranty Title Insurance': americanGuarantyIcon,
  'American Security Title Insurance Company': americanSecurityIcon,
  'AmTrust Title Insurance Company': amTrustIcon,
  'Arsenal Insurance Corp.': arsenalIcon,
  "Attorney's Title Guaranty Fund": attorneysTitleGuarantyFundIcon,
  'Bankers Guarantee Title & Trust Company': bankersGuaranteeIcon,
  'Chicago Title Insurance Company': chicagoTitleIcon,
  'Commonwealth Land Title Insurance Company': commonwealthLandIcon,
  'Conestoga Title Insurance Company': conestogaTitleIcon,
  'Connecticut Attorneys Title Insurance Company': caticIcon,
  'Dakota Homestead Title Insurance Company': dakotaHomesteadIcon,
  'DHI Title Insurance Company': dhiTitleIcon,
  'Doma Title Insurance, Inc.': domaTitleIcon,
  'EnTitle Insurance Company': entitleIcon,
  'Essent Guaranty, Inc.': essentIcon,
  'Essent Title Insurance, Inc.': essentIcon,
  'Fidelity National Title Insurance Company': fidelityNationalIcon,
  'First American Title Guaranty Company': defaultFAIcon,
  'First American Title Insurance Company': defaultFAIcon,
  'First American Title Insurance Company of Louisiana': defaultFAIcon,
  'First National Title Insurance Company': firstNationalIcon,
  'General Title Insurance Company': generalTitleIcon,
  'Impact Title Insurance Company': impactTitleIcon,
  'Investors Title Insurance Company': investorsTitleIcon,
  'Lighthouse Title Insurance Company': lighthouseTitleIcon,
  'National Investors Title Insurance Company': investorsTitleIcon,
  'National Title Insurance of New York': nationalTitleNYIcon,
  'Old Republic National Title Insurance Co.': oldRepublicIcon,
  Other: otherIcon,
  'Premier Land Title Insurance Company': premierLandTitleIcon,
  'Radian Title Insurance, Inc.': radianTitleIcon,
  'Real Advantage Title Insurance Company': realAdvantageTitleIcon,
  'Rocket Title Insurance Co.': rocketTitleIcon,
  'Security Title Guaranty': securityTitleGuarantyIcon,
  'Sierra Title Insurance Guaranty Company': sierraTitleIcon,
  'Southwest Land Title Insurance Company': southwestLandTitleIcon,
  'Stewart Title Guaranty Company': stewartTitleGuarantyIcon,
  'Texan Title Insurance Company': texanTitleIcon,
  'Title Resources Guaranty Company': titleResourcesGuarantyIcon,
  'US National Title Insurance Company': usNationalTitleIcon,
  'Westcor Land Title Insurance Company': westcorLandTitleIcon,
  'WFG National Title Insurance Company': wfgNationalTitleIcon,
  'Worth National Title Insurance Company': worthNationalTitleIcon,
};

export const DEFAULT_UNDERWRITER_ICON = defaultFAIcon;

export function getUnderwriterIcon(underwriterName: string): UnderwriterIconSrc {
  return UNDERWRITER_ICON_MAP[underwriterName] ?? DEFAULT_UNDERWRITER_ICON;
}

function toUnderwriterTestId(name: string): string {
  return `underwriter-${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')}`;
}

export function toConfigurationListItems(underwriterNames: string[]): ConfigurationListItem[] {
  return underwriterNames.map((title) => ({
    title,
    iconComponent: createElement('img', { src: getUnderwriterIcon(title), alt: title }),
    testId: toUnderwriterTestId(title),
  }));
}
